import PropTypes from "prop-types";
import React from "react";

import TiledBackground from "../TiledBackground";

import * as styles from "./styles.module.scss";

const Content = ({ children }) => (
  <TiledBackground>
    <div className={styles.contentContainer}>{children}</div>
  </TiledBackground>
);

Content.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Content;
